module.exports = __webpack_public_path__ + "img/play.67ff2c84.png";